import React from "react"
import PropTypes from "prop-types"
import makeStyles from "@material-ui/core/styles/makeStyles"
import {
  useTheme,
  useMediaQuery,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from "@material-ui/core"
import MenuIcon from "@material-ui/icons/Menu"
import Nav from "../bits/Nav"
import HeaderContact from "../bits/HeaderContact"
import AppDropdownMenu from "../bits/AppDropdownMenu"

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    fontFamily: ["Montserrat Alternates", "Montserrat", "sans-serif"].join(","),
    marginBottom: theme.spacing(1),
    maxHeight: 124,
  },
  AppBar: {
    zIndex: "unset",
    marginBottom: 0,
    boxShadow: "none",
    background: theme.palette.background.paper,
    color: theme.palette.primary.main,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logo: {
    fontFamily: "Montserrat Alternates",
    flexGrow: 1,
    flexShrink: 1,
    fontSize: theme.typography.fontSize + 35,
    fontWeight: 900,
    [theme.breakpoints.down(1200)]: {
      fontSize: theme.typography.fontSize + 30,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.fontSize + 12,
    },
  },
}))

const Header = ({ siteTitle }) => {
  const classes = useStyles(),
    theme = useTheme()
  const [state, setState] = React.useState({
    open: false,
  })

  const toggleDrawer = () => {
    setState({ ...state, open: !state.open })
  }

  const ShowNav = () => {
    const matches = useMediaQuery(theme.breakpoints.up("md"))
    return <>{matches ? <Nav /> : null}</>
  }

  const ShowMenuBtn = ({ toggleDrawer }) => {
    const matches = useMediaQuery(theme.breakpoints.down("sm"))
    return (
      <>
        {matches ? (
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
          >
            <MenuIcon />
          </IconButton>
        ) : null}
      </>
    )
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.AppBar}>
        <HeaderContact />
        <Toolbar>
          <Typography className={classes.logo}>Gloone</Typography>
          <ShowNav />
          <ShowMenuBtn toggleDrawer={toggleDrawer} />
          <AppDropdownMenu toggleDrawer={toggleDrawer} open={state.open} />
        </Toolbar>
      </AppBar>
    </div>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
